import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";


interface Post {
  _id: string;
  title: string;
  body: string;
  // Add any other properties as needed
}
export const PostList = () => {
  const [data, setData] = useState<Post[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("http://localhost:3000/posts", {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.msg);
        }

        const postData = await response.json();
        setData(postData);
      } catch (error) {
        console.error(error);
        alert("Please Login!");
        navigate("/login");
      }
    };

    fetchData();
  }, [navigate]);

  const handleEdit = (postId: any) => {
    console.log(postId);
    navigate(`/update/${postId}`);
  };

  const handleDelete = async (postId: any) => {
    try {
      const response = await fetch(`http://localhost:3000/posts/delete/${postId}`, {
        method: "DELETE",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.msg);
      }

      setData((prevData) => prevData.filter((item) => item._id !== postId));
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      <h3>Your Posts</h3>

      <PostGrid>
        {data.map((ele) => (
          <PostContainer key={ele._id}>
            <h3>{ele.title}</h3>
            <p>{ele.body}</p>
            <ButtonContainer>
              <button onClick={() => handleEdit(ele._id)}>Edit</button>
              <button onClick={() => handleDelete(ele._id)}>Delete</button>
            </ButtonContainer>
          </PostContainer>
        ))}
      </PostGrid>
    </div>
  );
};

const PostGrid = styled.div`
  display: grid;
  justify-content: space-evenly;
  grid-template-columns: repeat(2, 1fr);
`;

const PostContainer = styled.div`
  background-color: #d5e8e6;
  color: #4d3b4a;
  width: 400px;
  padding: 10px;
  margin: 30px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: 0.2rem solid #5c4859;
  border-radius: 10px;
  align-items: center;
`;

const ButtonContainer = styled.div`
  gap: 10px;
  font-size: larger;
  display: flex;

  button {
    background-color: #5c4859;
    color: #e2e9e8;
    width: 150px;
    height: 50px;
    padding: 5px;
    font-size: large;
    border-color: #bacac9;
    border-radius: 10px;
  }
`;
